import LoginPrompt from '../enums/login-prompt.enum';
import AuthType from '../enums/auth.type.enum';

export class AuthenticationEvent {
  public source?: string;
  public loginPrompt: LoginPrompt;
  public authType: AuthType;
  public siteGuid?: string;

  constructor(loginPrompt: LoginPrompt, authType: AuthType, siteGuid?: string, source?: string) {
    this.loginPrompt = loginPrompt;
    this.authType = authType;
    this.siteGuid = siteGuid;
    this.source = source;
  }
}
